"use client";
import { motion } from "framer-motion";
import Image from "next/image";

export function AboutStory() {
  return (
    <section id="about-story" className="py-24" data-header-scheme="light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-6 tracking-tight">
              Our Story
            </h2>
            <div className="space-y-4 text-lg text-muted-foreground">
              <p>
                The Plaster Shop was founded with a simple mission: make premium
                plaster and microcement accessible while connecting customers
                with skilled professionals who can bring their vision to life.
              </p>
              <p>
                We supply the highest quality Concretta microcement, Venetian
                plaster, and specialty finish products directly to homeowners,
                designers, and contractors. Our curated product selection
                ensures you get authentic, professional-grade materials for
                stunning results.
              </p>
              <p>
                Beyond products, we've built America's most comprehensive
                directory of verified plaster and microcement applicators.
                Whether you're planning a bathroom remodel, commercial space, or
                architectural project, we connect you with experienced
                professionals in your area who specialize in these unique
                finishes.
              </p>
              <p>
                Today, thousands of successful projects across the country have
                been completed through our network, from intimate residential
                bathrooms to expansive commercial installations.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-4/3 bg-card rounded-lg overflow-hidden shadow-2xl border border-border relative">
              <Image
                src="/images/home/available-colors/dark-jade-example.jpeg"
                alt="The Plaster Store Workshop"
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
